/**
 * File: AuthProvider.tsx
 * Path: apps/admin/src/modules/auth/components/AuthProvider.tsx
 * Description: Manages Firebase Authentication state. Refactored to use onIdTokenChanged to automatically sync custom claim updates.
 */

import React, { createContext, useContext } from "react";
import {
  useAuthProviderController,
  type AuthContextValue,
} from "@/modules/auth/hooks/useAuthProviderController";

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = useAuthProviderController();
  const { isLoading } = value;

  return (
    <AuthContext.Provider value={value}>
      {!isLoading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
